import React, { useEffect, useState } from "react";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

// ================== PERUBAHAN UTAMA ==================
// Mengimpor hook dan tipe data asli, bukan mock
import useOccupancyMonth from "../../../services/occupancy/hooks/useOccupancyMonth";
import { useAuth } from "../../../auth/context/AuthProvider";
// Sesuaikan path ke skeleton jika perlu
import OccupancyChartSkeleton from "../../pms-report/components/OccupancyChartSkeleton";
// =======================================================

const OccupancyHighChart: React.FC = () => {
    // Menggunakan hook asli
    const { user } = useAuth();
    const [chartOptions, setChartOptions] = useState<Highcharts.Options>({});

    // Logika pengambilan data diambil dari OccupancyChart
    const endDate = new Date();
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 11);
    startDate.setDate(1);

    const formatDate = (date: Date) => date.toISOString().slice(0, 10);

    const { data: occupancyData, isFetching } = useOccupancyMonth({
        filter: {
            start: formatDate(startDate),
            end: formatDate(endDate),
            property_id: user?.active_property_id ?? "",
        },
        enabled: !!user?.active_property_id,
    });

    useEffect(() => {
        if (occupancyData && occupancyData.data) {
            // Transformasi data untuk Highcharts (logika ini sudah benar)
            const monthLabels: Record<string, string> = {
                "01": "Jan", "02": "Feb", "03": "Mar", "04": "Apr", "05": "May", "06": "Jun",
                "07": "Jul", "08": "Aug", "09": "Sep", "10": "Oct", "11": "Nov", "12": "Dec",
            };

            // Urutkan data berdasarkan bulan untuk memastikan urutan chart benar
            const sortedData = [...occupancyData.data].sort((a, b) => a.month.localeCompare(b.month));

            const categories = sortedData.map(item => {
                const monthKey = item.month.split("-")[1];
                return monthLabels[monthKey];
            });

            const seriesData = sortedData.map(item => parseFloat(item.occupancy));

            setChartOptions({
                chart: {
                    type: 'spline' // 'spline' untuk garis melengkung seperti 'tension' di Chart.js
                },
                title: {
                    text: 'Occupancy Percentage (Last 12 Months)'
                },
                xAxis: {
                    categories: categories,
                    title: {
                        text: "Month"
                    }
                },
                yAxis: {
                    title: {
                        text: "Occupancy Percentage"
                    },
                    min: 0,
                    max: 100,
                    tickInterval: 10
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.y:.2f}%</b>'
                },
                plotOptions: {
                    spline: {
                        marker: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 4
                        }
                    }
                },
                series: [{
                    type: 'spline',
                    name: "Occupancy Percentage",
                    data: seriesData,
                    color: "#007bff"
                }],
                legend: {
                    enabled: true,
                    align: 'center',
                    verticalAlign: 'top'
                },
                credits: {
                    enabled: false
                }
            });
        }
    }, [occupancyData]);

    // Render logic disamakan dengan OccupancyChart
    return (
        <>
            {isFetching && <OccupancyChartSkeleton />}
            {!isFetching && chartOptions.series && (
                <div className="mt-4 p-3 bg-white rounded shadow-sm">
                    <div style={{ height: "400px" }}>
                        <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                    </div>
                </div>
            )}
        </>
    );
};

export default OccupancyHighChart;